import { OperatorPrivilege } from "../interfaces/OperatorInterface";
import SectionInterface from "../interfaces/SectionInterface";
import { isPreReleaseEnvironment } from "./Settings";

// 学習コーチングの申込一覧へのアクセス可否（ACC-01 / ACC-02）。
// サイドバー導線の出しわけと直接 URL アクセスガードはこの判定を共有する。
// 校舎の条件（メニュー提供校）と役割の条件（参照できる役割）はどちらも boron の判定結果を見るだけにする。
// privileges が未読み込み（undefined）の間は偽とする
export const isLearningCoachApplicationAccessible = (
  section: SectionInterface,
  privileges: OperatorPrivilege[] | undefined,
): boolean => {
  return (
    isPreReleaseEnvironment() &&
    !!section.learningCoachApplicationAvailable &&
    !!privileges?.includes("learning_coach_application:index")
  );
};

// 申込 URL の発行の入口を出せるか（ACC-03）。申込一覧を開けたうえで、起票できる役割かを boron の判定結果で見る
export const canIssueLearningCoachApplication = (
  privileges: OperatorPrivilege[] | undefined,
): boolean => !!privileges?.includes("learning_coach_application:create");
